import React from "react";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import { signOut } from "../../pages/Login/loginstate";

export const FALLBACK_MESSAGE =
  "Your account has been stopped. Please contact support for assistance.";

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 2000,
    width: "100vw",
    height: "100vh",
    background: "#f5f6f8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
  card: {
    maxWidth: 520,
    width: "100%",
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
    padding: "40px 32px",
    textAlign: "center",
  },
  title: { margin: "0 0 16px", fontSize: 24, color: "#1f2937" },
  message: {
    margin: "0 0 20px",
    fontSize: 16,
    lineHeight: 1.5,
    color: "#374151",
    whiteSpace: "pre-wrap",
  },
  support: { margin: "0 0 24px", fontSize: 14, color: "#6b7280" },
  link: { color: "#0966c2", fontWeight: 600, textDecoration: "none" },
  button: { textTransform: "none" },
};

export const DashboardLocked = ({ remark, signOut }) => {
  const message = (remark && remark.trim()) || FALLBACK_MESSAGE;
  return (
    <div id="dashboard-locked" style={styles.overlay}>
      <div style={styles.card}>
        <h1 style={styles.title}>Account Stopped</h1>
        <p style={styles.message}>{message}</p>
        <p style={styles.support}>
          Need help? Contact{" "}
          <a href="mailto:partnership.support@aisensy.com" style={styles.link}>
            partnership.support@aisensy.com
          </a>
        </p>
        <Button
          variant="contained"
          color="primary"
          onClick={() => signOut()}
          style={styles.button}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default connect(null, { signOut })(DashboardLocked);
